import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { readableTypeName } from '@iotv/core-services';
import { Alert, CircularProgress } from '@mui/material';
import { AdjacentType } from '../../../types';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
/**
 * Basic card for displaying details of an object linked to a {@link matchedPrimary} if _cardinality_ to that object is **1**
 *
 * @note queries {@link applicationData}, does not fetch from the datastore!
 */
export const CardinalityOneCard = ({ matchedPrimary, adjacentFilter, applicationData, userFunctions, transactionFunctions }) => {
    const relevantConnections = adjacentFilter.adjacentType === AdjacentType.PARENT
        ? applicationData?.getParentNodes(matchedPrimary).filter((n) => n.type === adjacentFilter.objectType)
        : applicationData?.getChildNodes(matchedPrimary).filter((n) => n.type === adjacentFilter.objectType);
    const relevantObj = relevantConnections ? (relevantConnections[0] ?? null) : undefined;
    return applicationData === undefined || relevantObj === undefined ? (_jsx(CircularProgress, {})) : relevantObj === null ? (_jsxs(Alert, { severity: "info", children: ["No ", readableTypeName(adjacentFilter.objectType), " is linked to ", matchedPrimary.name] })) : (_jsx(ObjectDetailCard, { matchedPrimary: relevantObj, showContextSubCard: false, userFunctions: userFunctions, transactionFunctions: transactionFunctions }));
};
